"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Scrollbar;
exports.OverlayScroll = OverlayScroll;
exports.ScrollValue = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _overlayscrollbars = _interopRequireDefault(require("overlayscrollbars"));

var _overlayscrollbarsReact = require("overlayscrollbars-react");

var _reactCustomScrollbars = require("react-custom-scrollbars");

var _reactResizeDetectorOld = _interopRequireWildcard(require("react-resize-detector-old"));

var _ = require("../");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ScrollValue = _react.default.createContext(0);

exports.ScrollValue = ScrollValue;

function Scrollbar(_ref) {
  var children = _ref.children,
      disable = _ref.disable,
      rest = _objectWithoutProperties(_ref, ["children", "disable"]);

  // const { width, height, ref } = useResizeDetector();
  if (disable) {
    return children;
  }

  return /*#__PURE__*/_react.default.createElement(_reactResizeDetectorOld.default, {
    handleWidth: true,
    handleHeight: true
  }, function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return /*#__PURE__*/_react.default.createElement(_reactCustomScrollbars.Scrollbars, _extends({
      style: {
        width: width,
        height: height
      },
      hideTracksWhenNotNeeded: true
    }, (0, _.ui)(_.uiWrapperScroll), rest), children);
  }); // return (
  //   <ReactResizeDetector
  //     handleWidth
  //     handleHeight
  //   >
  //     {({
  //       width,
  //       height,
  //     }) => (console.log(`width ${width} / height ${height}`),
  //       <
  //         style={{
  //           width: `${width}px`,
  //           height: `${height}px`,
  //         }}
  //         hideTracksWhenNotNeeded
  //         {...ui(uiWrapperScroll)}
  //         {...rest}
  //       >
  //         {children}
  //       </Scrollbars>
  //     )}
  //   </ReactResizeDetector>
  // );
}

function OverlayScroll(_ref3) {
  var children = _ref3.children,
      options = _ref3.options,
      className = _ref3.options.className,
      disable = _ref3.disable,
      rest = _objectWithoutProperties(_ref3, ["children", "options", "options", "disable"]);

  // const { width, height, ref } = useResizeDetector();
  if (disable) {
    return children;
  }

  var updatedOptions = _objectSpread(_objectSpread({}, options), {}, {
    className: "".concat(className, " os-theme-dark")
  });

  return /*#__PURE__*/_react.default.createElement(_overlayscrollbarsReact.OverlayScrollbarsComponent, _extends({
    options: updatedOptions
  }, rest), children);
}

Scrollbar.propTypes = {
  children: _propTypes.default.node.isRequired,
  disable: _propTypes.default.bool
};
Scrollbar.defaultProp = {
  disable: false
};
OverlayScroll.propTypes = {
  children: _propTypes.default.node.isRequired,
  disable: _propTypes.default.bool,
  options: _propTypes.default.object,
  className: _propTypes.default.string
};
OverlayScroll.defaultProp = {
  disable: false,
  options: {},
  className: ''
};